module.exports = __webpack_public_path__ + "img/help_register_hf@3x.74ce612e.png";